<template>
  <div @click="clickMarker" ref="sceneViewMarker" class="sceneViewMarker alibabaPuHuiTiFontFamily">
    <img src="../../../assets/globe/scene/viewPoint/viewPointMapIcon.png" style="width:100%;">
    <div style="position:absolute;top:-6px;left:-6px;width:18px;height:18px;background:#ffffff;border-radius:2px;box-shadow:0px 1px 3px rgba(0, 0, 0, 0.8);
    text-align:center;color:#383838;font-size:14px;">
      <p v-show="!markerInfo.isZoomBasis" style="line-height:18px;">{{markerIndex+1}}</p>
      <p v-show="markerInfo.isZoomBasis" style="line-height:18px;color:#00B3FF;font-size:16px;" class="iconfontFamily">&#xe683;</p>
    </div>
  </div>
</template>

<script>
import mapboxgl from "mapbox-gl";

export default {
  name: "SceneViewMarker",
  props:["markerInfo","markerIndex"],
  data() {
    return {
      marker: ''
    }
  },
  methods:{
    clickMarker(){
      this.$emit("clickMarker",this.markerInfo)
    }
  },
  mounted() {
    console.log("2222")
    this.marker = new mapboxgl.Marker(this.$refs.sceneViewMarker)
        .setLngLat([this.markerInfo.lng, this.markerInfo.lat])
        .addTo(this.$parent.$parent.map)
  },
  destroyed() {
    console.log("11111")
    this.marker.remove()
  },
  render() {
    return null;
  },

}
</script>

<style scoped>

.sceneViewMarker{
  position:absolute;
  width:42px;
  height:55px;
  cursor:pointer;
}



</style>